import { Reveal } from "./Reveal";

const COACH_IMG =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_bootcamp-gains/artifacts/5y2r1css_Jcfitness%20smile.jpg";

const stats = [
  { n: "10+", l: "Years coaching" },
  { n: "500+", l: "Clients transformed" },
  { n: "50+", l: "Bootcamps run" },
];

export default function About() {
  return (
    <section id="about" className="bg-[#050505] py-24 md:py-40 border-t border-[#222]" data-testid="about">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
        <Reveal className="md:col-span-5">
          <div className="relative border border-[#222] overflow-hidden">
            <img src={COACH_IMG} alt="Coach Jean Claude" className="w-full h-[420px] md:h-[560px] object-cover object-[65%_center]" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/70 to-transparent" />
            <div className="absolute bottom-6 left-6">
              <p className="font-mono-accent text-[10px] text-[#005EEA]">Head Coach</p>
              <p className="font-display text-white text-2xl leading-none mt-1">Jean Claude</p>
            </div>
          </div>
        </Reveal>

        <div className="md:col-span-7">
          <Reveal>
            <p className="font-mono-accent text-[#005EEA] text-xs mb-4">The Coach</p>
            <h2 className="font-display text-white text-4xl md:text-6xl leading-[0.9] mb-8">
              I don't sell workouts.<br />I build athletes.
            </h2>
            <p className="text-[#A0A0A0] text-lg leading-relaxed mb-6 max-w-2xl">
              For over a decade I've coached everyone from first-timers to competitive athletes.
              My approach is simple: understand your body, respect the process, and train with
              intent. Whether you want to drop weight, get strong, or dominate your sport — we build
              the plan around <span className="text-white">you</span>.
            </p>
            <p className="text-[#A0A0A0] text-lg leading-relaxed max-w-2xl">
              Every journey starts with a free consultation. No pressure, just a conversation about
              where you are and where you want to be.
            </p>

            <div className="mt-12 grid grid-cols-3 gap-6 border-t border-[#222] pt-10">
              {stats.map((s) => (
                <div key={s.l}>
                  <p className="font-display text-white text-4xl md:text-6xl leading-none">{s.n}</p>
                  <p className="font-mono-accent text-[10px] text-[#666] mt-2">{s.l}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
